import {useEffect, useState} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns, atomButtonShapes} from '@s-ui/react-atom-button'
import {useAdvertising} from '@adv-mt/advertising-publift'
import {PanelBasic} from '@adv-mt/mt-panel-basic'
import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

import {clickUrlTransformationService} from '../clickUrlTransformationService/index.js'

const BASE_CLASS = 'mt-NewInsuranceCard'

export default function NewInsuranceCard({
  icon,
  clickUrl,
  handleClick,
  buttonTitle,
  logosUrl,
  regularText,
  boldText,
  logoAltText
}) {
  const {advertisingPageData} = useAdvertising()
  const [transformedUrl, setTransformedUrl] = useState(null)

  useEffect(() => {
    if (advertisingPageData) {
      setTransformedUrl(
        clickUrlTransformationService({
          clickUrl,
          pageData: advertisingPageData
        })
      )
    }
  }, [advertisingPageData, clickUrl])

  const button = (
    <AtomButton
      design={atomButtonDesigns.OUTLINE}
      fullWidth
      href={transformedUrl}
      onClick={handleClick}
      link
      rel="noreferrer"
      shape={atomButtonShapes.CIRCULAR}
      leftIcon={icon}
      target="_blank"
    >
      <span>{buttonTitle}</span>
    </AtomButton>
  )

  return (
    <PanelBasic>
      <div className={BASE_CLASS}>
        <div className={`${BASE_CLASS}-contentWrapper`}>
          <div className={`${BASE_CLASS}-content`}>
            <div className={`${BASE_CLASS}-title`}>
              <div className={`${BASE_CLASS}-titleWrapper`}>
                <TitleBasic as={titleBasicTags.h2} size={titleBasicSizes.xs} title={buttonTitle} />
                <p className={`${BASE_CLASS}-titleDescription`}>
                  {regularText} <span className={`${BASE_CLASS}-titleDescriptionBold`}>{boldText}</span>
                </p>
              </div>
            </div>
            <div className={`${BASE_CLASS}-section`}>
              <div className={`${BASE_CLASS}-buttonWrapper`}>{button}</div>
            </div>
          </div>
        </div>
        <div className={`${BASE_CLASS}-imageContainer`}>
          <img className={`${BASE_CLASS}-imageContainerImage`} src={logosUrl} alt={logoAltText} />
        </div>{' '}
      </div>
    </PanelBasic>
  )
}

NewInsuranceCard.propTypes = {
  icon: PropTypes.node,
  logosUrl: PropTypes.string,
  clickUrl: PropTypes.string,
  handleClick: PropTypes.func,
  buttonTitle: PropTypes.string,
  regularText: PropTypes.string,
  boldText: PropTypes.string,
  logoAltText: PropTypes.string
}
